import pageHeader from "../components/pageHeader/locals/ar.json";
import productsSection from "../components/productsSection/locals/ar.json";

export default {
  pageHeader,
  productsSection,
};